




















































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CardTitle from "./CardTitle.vue";
import { bus } from "../main";
import { DocAttestatoFinale } from "../_models/docAttestatoFinale";
import * as user from "../_store/user.module";
import * as data from "../_store/data.module";

@Component({
  components: {
    CardTitle
  }
})
export default class AttestatoFinale extends Vue {
  @Prop() info!: any;
  @Prop() dialogParams!: any;
  @Prop() activityType!: string;

  private dialog: boolean;
  private totOre: number;
  private noteAggiuntive: string;
  private dataAttestato: string;
  private currentDay: string;
  private luogoAttestato: string;
  private gruppoUno: string;
  private gruppoDue: string;
  private gruppoTre: string;
  private gruppoQuattro: string;
  private gruppoCinque: string;
  private gruppoSei: string;
  private gruppoSette: string;
  private gruppoOtto: string;
  private gruppoNove: string;
  private gruppoDieci: string;

  private gruppoUnoError: boolean;
  private gruppoDueError: boolean;
  private gruppoTreError: boolean;
  private gruppoQuattroError: boolean;
  private gruppoCinqueError: boolean;
  private gruppoSeiError: boolean;
  private gruppoSetteError: boolean;
  private gruppoOttoError: boolean;
  private gruppoNoveError: boolean;
  private gruppoDieciError: boolean;

  private totOreRules: [boolean | string];
  private errorGroup: boolean;

  private firmaTutorAzienda: string;
  private startDate: any;
  private finishDate: any;
  private startMenu: boolean;
  private finishMenu: boolean;

  private tipoAttivita: string;
  private listaFirme: any;

  private dataInizio: string;
  private dataFine: string;

  private startDateRules: [boolean | string];
  private finishDateRules: [boolean | string];

  constructor() {
    super();
    this.startDate = new Date().toISOString().substr(0, 10);
    this.finishDate = new Date().toISOString().substr(0, 10);
    this.startMenu = false;
    this.finishMenu = false;
    this.dialog = false;
    this.totOre = 0;
    this.noteAggiuntive = "";
    this.dataAttestato = "";
    this.currentDay = new Date().toISOString().substr(0, 10);
    this.luogoAttestato = this.info.comuneAzienda;
    this.gruppoUno = "";
    this.gruppoDue = "";
    this.gruppoTre = "";
    this.gruppoQuattro = "";
    this.gruppoCinque = "";
    this.gruppoSei = "";
    this.gruppoSette = "";
    this.gruppoOtto = "";
    this.gruppoNove = "";
    this.gruppoDieci = "";
    this.firmaTutorAzienda = "";

    this.gruppoUnoError = false;
    this.gruppoDueError = false;
    this.gruppoTreError = false;
    this.gruppoQuattroError = false;
    this.gruppoCinqueError = false;
    this.gruppoCinqueError = false;
    this.gruppoSeiError = false;
    this.gruppoSetteError = false;
    this.gruppoOttoError = false;
    this.gruppoNoveError = false;
    this.gruppoDieciError = false;

    this.totOreRules = [true];
    this.startDateRules = [true];
    this.finishDateRules = [true];
    this.errorGroup = false;

    this.tipoAttivita = "";
    this.listaFirme = [];
    this.dataInizio = "";
    this.dataFine = "";
  }

  @Watch("gruppoUno")
  onchangeGruppoUno() {
    if (this.gruppoUno !== "") {
      this.gruppoUnoError = false;
    }
  }

  @Watch("gruppoDue")
  onchangeGruppoDue() {
    if (this.gruppoDue !== "") {
      this.gruppoDueError = false;
    }
  }

  @Watch("gruppoTre")
  onchangeGruppoTre() {
    if (this.gruppoTre !== "") {
      this.gruppoTreError = false;
    }
  }

  @Watch("gruppoQuattro")
  onchangeGruppoQuattro() {
    if (this.gruppoQuattro !== "") {
      this.gruppoQuattroError = false;
    }
  }

  @Watch("gruppoCinque")
  onchangeGruppoCinque() {
    if (this.gruppoCinque !== "") {
      this.gruppoCinqueError = false;
    }
  }

  @Watch("gruppoSei")
  onchangeGruppoSei() {
    if (this.gruppoSei !== "") {
      this.gruppoSeiError = false;
    }
  }

  @Watch("gruppoSette")
  onchangeGruppoSette() {
    if (this.gruppoSette !== "") {
      this.gruppoSetteError = false;
    }
  }

  @Watch("gruppoOtto")
  onchangeGruppoOtto() {
    if (this.gruppoOtto !== "") {
      this.gruppoOttoError = false;
    }
  }

  @Watch("gruppoNove")
  onchangeGruppoNove() {
    if (this.gruppoNove !== "") {
      this.gruppoNoveError = false;
    }
  }

  @Watch("gruppoDieci")
  onchangeGruppoDieci() {
    if (this.gruppoDieci !== "") {
      this.gruppoDieciError = false;
    }
  }

  close() {
    var currentDate = new Date();
    this.dialog = false;
    this.totOre = 0;
    this.noteAggiuntive = "";
    this.dataAttestato =
      currentDate.getDate() +
      "/" +
      (currentDate.getMonth() + 1) +
      "/" +
      currentDate.getFullYear();
    this.luogoAttestato = this.info.comuneAzienda;
    this.gruppoUno = "";
    this.gruppoDue = "";
    this.gruppoTre = "";
    this.gruppoQuattro = "";
    this.gruppoCinque = "";
    this.gruppoSei = "";
    this.gruppoSette = "";
    this.gruppoOtto = "";
    this.gruppoNove = "";
    this.gruppoDieci = "";
    this.firmaTutorAzienda = "";
    this.clearEnterpriseSignature();
    bus.$emit("closeAttestatoFinaleDialog");
  }

  clearEnterpriseSignature() {
    //@ts-ignore
    this.$refs.enterpriseSignaturePad.clearSignature();
  }

  validateGroups() {
    if (this.gruppoUno === "") {
      this.gruppoUnoError = true;
      this.errorGroup = true;
    }
    if (this.gruppoDue === "") {
      this.gruppoDueError = true;
      this.errorGroup = true;
    }
    if (this.gruppoTre === "") {
      this.gruppoTreError = true;
      this.errorGroup = true;
    }
    if (this.gruppoQuattro === "") {
      this.gruppoQuattroError = true;
      this.errorGroup = true;
    }
    if (this.gruppoCinque === "") {
      this.gruppoCinqueError = true;
      this.errorGroup = true;
    }
    if (this.gruppoSei === "") {
      this.gruppoSeiError = true;
      this.errorGroup = true;
    }
    if (this.gruppoSette === "") {
      this.gruppoSetteError = true;
      this.errorGroup = true;
    }
    if (this.gruppoOtto === "") {
      this.gruppoOttoError = true;
      this.errorGroup = true;
    }
    if (this.gruppoNove === "") {
      this.gruppoNoveError = true;
      this.errorGroup = true;
    }
    if (this.gruppoDieci === "") {
      this.gruppoDieciError = true;
      this.errorGroup = true;
    }
  }

  validateOre() {
    if (this.totOre !== 0) {
      this.totOreRules = [true];
    } else {
      this.totOreRules = ["Inserire Totale Ore"];
    }
  }

  validazioneDataInizio() {
    if (this.startDate !== null && this.startDate !== "") {
      this.startDateRules = [true];
    } else {
      this.startDateRules = ["Data inizio attività necessaria"];
    }
  }

  validazioneDataFine() {
    if (this.finishDate !== null && this.finishDate !== "") {
      this.finishDateRules = [true];
    } else {
      this.finishDateRules = ["Data fine attività necessaria"];
    }
  }

  loadFirme() {
    var payload = {
      idRichiesta: this.info.idRichiesta,
      activityType: this.activityType
    };
    data
      .dispatchElencoFirme(this["$store"], payload)
      .then(result => {
        this.listaFirme = result;
        for (let i = 0; i < result.length; i++) {
          this.totOre = this.totOre + result[i].oreGiornaliere;
        }
        this.dataInizio = this.parseDate(result[0].dataFirma).toLocaleString(
          ["it-IT"],
          {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
          }
        );
        this.dataFine = this.parseDate(
          result[result.length - 1].dataFirma
        ).toLocaleString(["it-IT"], {
          day: "2-digit",
          month: "2-digit",
          year: "numeric"
        });
        this.startDate = this.parseDate(this.dataInizio).toISOString().substr(0, 10);
        this.finishDate = this.parseDate(this.dataFine).toISOString().substr(0, 10);
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  parseDate(date: string): Date {
    var tmpStr = "";
    var strArray = [];
    var finalDate = "";
    strArray = date.split("/");
    tmpStr = strArray[2] + "-" + strArray[1] + "-" + strArray[0];
    var tmpDate = new Date(tmpStr);
    return tmpDate;
  }

  async executeTest() {
    this.validateGroups();
    this.validateOre();
    this.validazioneDataInizio();
    this.validazioneDataFine();
  }

  save() {
    //@ts-ignore
    const signature = this.$refs.enterpriseSignaturePad.saveSignature();
    if (signature.isEmpty === false) {
      this.executeTest().then(() => {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
          if (this.errorGroup === false) {
            var attestatoInfo: DocAttestatoFinale = {
              idAttestatoFinale: 0,
              dataInizioPeriodo: this.startDate,
              dataFinePeriodo: this.finishDate,
              denominazioneAzienda: this.info.denominazioneAzienda,
              allievo: this.info.allievo,
              classeAllievo: this.info.classe,
              totaleOre: +this.totOre,
              noteAggiuntive: this.noteAggiuntive,
              dataAttestato: this.currentDay,
              luogoAttestato: this.luogoAttestato,
              gruppoUno: +this.gruppoUno,
              gruppoDue: +this.gruppoDue,
              gruppoTre: +this.gruppoTre,
              gruppoQuattro: +this.gruppoQuattro,
              gruppoCinque: +this.gruppoCinque,
              gruppoSei: +this.gruppoSei,
              gruppoSette: +this.gruppoSette,
              gruppoOtto: +this.gruppoOtto,
              gruppoNove: +this.gruppoNove,
              gruppoDieci: +this.gruppoDieci,
              firmaTutorAzienda: signature.data,
              tipoAttivita: this.activityType,
              idRichiesta: this.info.idRichiesta,
              numeroProtocollo: this.info.numeroProtocollo,
              dataProtocollo: this.info.dataProtocollazione,
              idTutorAzienda: this.info.idTutorAzienda,
              tutorAzienda: this.info.tutorAzienda,
              tutorFormativo: this.info.tutorFormativo
            };
            user
              .dispatchCreateAttestatoFinale(this["$store"], attestatoInfo)
              .then(() => {
                bus.$emit(
                  "successfullOperation",
                  "Attestato finale inviato. Ricordati di compilare il QUESTIONARIO DI GRADIMENTO"
                );
                this.close();
                bus.$emit("loadAssegnazioni");
              })
              .catch(error => {
                if (error.response.status === 403) {
                  bus.$emit("errorOperation", error.response.statusText);
                  this["$router"].push("/login");
                } else {
                  bus.$emit("errorOperation", error.response.statusText);
                }
              });
          } else {
            bus.$emit(
              "errorOperation",
              "Uno o più campi sono senza valutazione"
            );
            this.errorGroup = false;
          }
        } else {
          bus.$emit("errorOperation", "Inserire numero totale di ore svolto");
        }
      });
    } else {
      bus.$emit("errorOperation", "Firma mancante");
    }
  }

  created() {
    this.loadFirme();
    if (this.activityType === "alternanza") {
      this.tipoAttivita = "FSL Estiva";
    } else if (this.activityType === "tirocinioEstivo") {
      this.tipoAttivita = "Tirocinio Estivo";
    }
    var currentDate = new Date();
    this.dataAttestato =
      currentDate.getDate() +
      "/" +
      (currentDate.getMonth() + 1) +
      "/" +
      currentDate.getFullYear();
  }
}
